module.exports = __webpack_public_path__ + "static/media/Doan_Ngoc_Khanh.20672547.jpg";